export const DateFormat = ({ dateString }) => {
  const date = new Date(dateString);

  if (isNaN(date)) {
    return "Invalid Date";
  }
  const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Africa/Casablanca',
  };
  return date.toLocaleString('en-US', options);
};
